import absoluteUrl from 'next-absolute-url'

import Article from 'containers/Article'

import Layout from 'components/Layout'
import MetaTags from 'components/MetaTags'

export default function Index({ canonical }) {
  const title = 'Our Community'

  return (
    <>
      <MetaTags title={title} ogType="article" section={title} pathUrl={canonical} />

      <Layout>
        <Article />
      </Layout>
    </>
  )
}

export async function getServerSideProps(context) {
  const { req, res } = context
  const { origin } = absoluteUrl(req)

  res.setHeader('Cache-Control', 'public, s-maxage=60, stale-while-revalidate=59')

  return {
    props: JSON.parse(
      JSON.stringify({
        canonical: `${origin}/blog`,
      })
    ),
  }
}
